import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryDegreeType extends TitleBase {
	private countryValue: string;
	private degreeTypeValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE)
		);
	}

	protected getPageTitle(): string {
		return `${this.degreeTypeValue} in ${this.countryValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${degreeTypeValue} in ${this.countryValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.degreeTypeValue, ` in ${this.countryValue}`);
	}
}
